import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Page title row with optional back navigation.
 */
export function PageHeader({ title, subtitle, backTo, icon: Icon, actions }) {
  const navigate = useNavigate();
  const { isRTL } = useLanguage();

  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex min-w-0 items-start gap-3">
        {backTo ? (
          <button
            type="button"
            onClick={() => navigate(backTo)}
            className="tap-target flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-zinc-200 bg-white text-zinc-700 shadow-sm transition hover:bg-zinc-50"
            aria-label="Back"
          >
            <ArrowLeft className={`h-5 w-5 ${isRTL ? 'rotate-180' : ''}`} />
          </button>
        ) : null}
        <div className="min-w-0">
          <h1 className="flex flex-wrap items-center gap-3 text-2xl font-bold tracking-tight text-zinc-900 sm:text-3xl">
            {Icon ? (
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-100 text-brand-800">
                <Icon className="h-6 w-6" />
              </span>
            ) : null}
            <span>{title}</span>
          </h1>
          {subtitle ? <p className="mt-1 text-sm text-zinc-600 sm:text-base">{subtitle}</p> : null}
        </div>
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap gap-2">{actions}</div> : null}
    </div>
  );
}
